import { X } from "lucide-react";

export default function RecordDetailModal({ title, subtitle, badge, sections = [], onClose, children }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-slate-900/50 backdrop-blur-sm p-4 overflow-y-auto"
      onMouseDown={onClose} data-testid="record-detail-overlay">
      <div onMouseDown={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-8 animate-fade-up" data-testid="record-detail-modal">
        <div className="flex items-start justify-between px-6 py-4 border-b border-slate-100 sticky top-0 bg-white rounded-t-2xl z-10">
          <div>
            <h3 className="font-display font-bold text-[17px] text-slate-900">{title}</h3>
            {subtitle && <p className="text-[12.5px] text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">
            {badge}
            <button onClick={onClose} data-testid="record-detail-close" className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
          </div>
        </div>
        <div className="px-6 py-5 space-y-5">
          {children}
          {sections.map((sec, si) => (
            <div key={si}>
              {sec.heading && <div className="pq-label mb-2">{sec.heading}</div>}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {sec.fields.filter(Boolean).map((f, fi) => (
                  <div key={fi} className={f.full ? "sm:col-span-2" : ""}>
                    <div className="text-[10.5px] uppercase tracking-wide text-slate-400 font-semibold mb-0.5">{f.label}</div>
                    <div className="text-[13.5px] text-slate-800 font-medium break-words" data-testid={f.testid}>
                      {f.value || f.value === 0 ? f.value : "—"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
